import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.xsell.xsell_title.title',
        defaultMessage: 'You’ve been approved for {amount}'
    },
    expiryDate: {
        id: '_.xsell.xsell_title.expiry_date',
        defaultMessage: 'Valid until {date}'
    },
    subTitle: {
        id: '_.xsell.xsell_title.sub_title',
        defaultMessage: 'Select an offer below to continue.'
    },
    subheaderOne: {
        id: '_.xsell.xsell_title.subheader_one',
        defaultMessage: 'Get your own account manager'
    },
    subheaderTwo: {
        id: '_.xsell.xsell_title.subheader_two',
        defaultMessage: 'Top up your loan in a few clicks'
    },
    subheaderThree: {
        id: '_.xsell.xsell_title.subheader_three',

        defaultMessage: 'No early repayment fees'
    }
});
